import styled from "styled-components";

import { useDispatch, useSelector } from "services/redux/rootReducer";

import { TableAction } from "../../../types/actions.table";
import { EditorAction } from "../../../types/actions.editor";

import Modal from "features/shared/components/modal";
import ModalHeader from "../../modals/modalHeader";
import LabelWrapper from "../../form/components/labelWrapper";
import CustomCheckbox from "../../table/components/customCheckbox";

const SettingsModal: React.FC = () => {
    const dispatch = useDispatch();
    const { tableDefinition } = useSelector((state) => state.table);

    const handleClose = () => {
        dispatch({
            type: EditorAction.TOGGLE_MODAL,
        });
    };

    const handleToggleColumnShown = (accessor: string, isShown: boolean) => {
        dispatch({
            type: TableAction.SET_COLUMN_SHOWN,
            accessor,
            isShown,
        });
    };

    const displayedColumnToggleSwitches = tableDefinition.rowTemplate.map(
        (row) => (
            <ColumnOption
                key={row.accessor}
                onClick={() =>
                    handleToggleColumnShown(row.accessor, !row.isShown)
                }
            >
                <span>{row.header.toUpperCase()}</span>
                <CustomCheckbox
                    isChecked={row.isShown}
                    onClickHandler={() =>
                        handleToggleColumnShown(row.accessor, !row.isShown)
                    }
                />
            </ColumnOption>
        )
    );

    return (
        <Modal id="menuBarSettings" onCloseHandler={handleClose}>
            <ModalContainer>
                <ModalHeader
                    onCloseHandler={handleClose}
                    headingText="Settings"
                />
                <Container>
                    <LabelWrapper label="Displayed Columns">
                        <ColumnOptionsContainer>
                            {displayedColumnToggleSwitches}
                        </ColumnOptionsContainer>
                    </LabelWrapper>
                </Container>
            </ModalContainer>
        </Modal>
    );
};

const ModalContainer = styled.div`
    background: ${(props) => props.theme.colors.neutral[100]};
    color: ${(props) => props.theme.colors.neutral[800]};
    height: 50vh;
    width: 30vw;

    border-radius: 0.2rem;
    overflow: hidden;

    resize: both;

    display: flex;
    flex-flow: column;

    & > *:first-child {
        flex: 0 0 4rem;
    }

    & > *:nth-child(2) {
        flex: 1;
    }

    @media (max-width: 768px) {
        height: 70vh;
        width: 95vw;
    }
`;

const Container = styled.div`
    display: flex;
    flex-flow: column;
    padding: 5%;
    overflow: auto;
`;

const ColumnOptionsContainer = styled.div`
    display: flex;
    flex-flow: column;
    gap: 0.5rem;

    padding: 0.25rem;

    border-radius: 0.2rem;
`;

const ColumnOption = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    user-select: none;

    padding: 0 1rem;

    height: 3rem;
    border-radius: 0.2rem;

    background: white;
    color: ${(props) => props.theme.colors.primary[200]};

    cursor: pointer;

    font-size: 0.9rem;
    font-weight: ${(props) => props.theme.fontWeight.bold};

    &:hover {
        background-color: ${(props) => props.theme.colors.primary[50] + "44"};
    }
`;

export default SettingsModal;
